import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
// Update the import path if necessary; for example, if the correct path is '../../../services/global.service', use:
import { GlobalService } from '../../../services/global.service';
// Or, if the file does not exist, create it with a basic service definition:

@Component({
    selector: 'app-clips-slider',
    templateUrl: './clips-slider.component.html',
    styleUrls: ['./clips-slider.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClipsSliderComponent implements OnInit {

	@Input() position: number;
	@Input() clips: any;
	toggleDetail: boolean = true;

	@Output() closeView = new EventEmitter<any>();

	next() {
		if (this.position + 1 == this.clips.length) {
			this.position = 0
		} else {
			this.position++
		}
	}
	previous() {
		if (this.position == 0) {
			this.position = this.clips.length - 1
		} else {
			this.position--
		}
	}

	close() {
		this.closeView.emit()
	}

	changeToggleDetail() {
		this.toggleDetail = !this.toggleDetail
	}
	getUserLong() {
		if (this._gS.user) {
			return this._gS.user.surename.toUpperCase() + ', ' + this._gS.user.given_name.toLowerCase()
		}
		return '--'
	}

	constructor(
		public _gS: GlobalService,
	) { }

	

	ngOnInit(): void {

	}

}
